import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { filter, find, findIndex } from 'lodash';
import {
  Context,
  Tarea,
  ConfigFinishDefault,
  DynamicComponentForm,
  TaskEvent,
  FuncionDocumento,
  Documento,
  DocumentoDetalle,
  HistorialDocumento,
  RevisionDocumento,
  ConfirmComponent,
  Const,
  DocumentoGenerado
} from '@app/shared';

@Component({
  selector: 'iw-elaborate',
  templateUrl: './elaborate.component.html',
  styleUrls: ['./elaborate.component.scss']
})
export class ElaborateComponent extends DynamicComponentForm implements OnInit {

  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Tarea actual
  task: Tarea;
  // Activa el btn de finalizar si hay una opción seleccionada
  isDisabledBtnFinish = true;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define si la tarea esta finalizada
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // Extensiones de los archivos permitidas
  extensions: Array<String> = [
    'image/tiff-fx',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'image/jpg',
    'image/png',
    'image/jpeg',
    'image/tif',
    'image/tiff',
  ];
  // Label de las extensiones permitidas
  extensionsLabel = 'jpg, png, pdf, xlsx, xls, docx, doc, tiff, tif';
  // Documentos descargados
  private _documentsDownload: any[] = [];
  // Documentos generados
  private _documentsGenerated: DocumentoGenerado[] = [];
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;

  constructor(private toastr: ToastrService) {
    super();
  }

  ngOnInit() {
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }
    this.validDocs();
  }

  set documentsDownload(docs: any[]) {
    this._documentsDownload = docs;
    this.validDocs();
  }

  get documentsDownload(): any[] {
    return this._documentsDownload;
  }

  set documentsGenerated(docs: DocumentoGenerado[]) {
    this._documentsGenerated = docs;
    this.validDocs();
  }

  get documentsGenerated(): DocumentoGenerado[] {
    return this._documentsGenerated;
  }

  /**
   * Finaliza la tarea
   *
   * @param {boolean} res
   * @memberof ElaborateComponent
   */
  finish(res: boolean) {
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }

  /**
   * actualiza la informacion de la tarea con respecto a los documentos subidos
   *
   * @param {*} data
   * @returns {*}
   * @memberof ElaborateComponent
   */
  documentUpdate(data: Documento[]): any {

    data.forEach(newDoc => {
      // Copiando funciones del documento
      const functionD: FuncionDocumento[] = [];
      newDoc.funciones.forEach(fun => {
        functionD.push({
          funcion: fun.funcion,
          id_funcion: fun.id_funcion,
          obligatorio: fun.obligatorio
        });
      });
      // Copienado documentos detalle del documento
      const detailDocument: DocumentoDetalle[] = [];
      newDoc.documentos_detalle.forEach(detail => {
        // Copiando historial del docuemnto
        const record: HistorialDocumento[] = [];
        if (detail.historial && detail.historial.length) {
          detail.historial.forEach(history => {
            // Copiando revisiones del registro de historial del documento
            const revisions: RevisionDocumento[] = [];
            if (history.revision && history.revision.length) {
              history.revision.forEach(revision => {
                revisions.push({
                  id_revision: revision.id_revision,
                  id_tarea: revision.id_tarea,
                  reponsable_id: revision.reponsable_id,
                  nombre_tarea: revision.nombre_tarea,
                  descripcion: revision.descripcion,
                  nombre_responsable: revision.nombre_responsable,
                  apellidos_responsable: revision.apellidos_responsable,
                  fecha: revision.fecha,
                  revision: revision.revision,
                  historial_id: revision.historial_id,
                  version: revision.version,
                  opcion: revision.opcion
                });
              });
            }
            record.push({
              id: history.id,
              nombre: history.nombre,
              nombre_archivo: history.nombre_archivo,
              extension: history.extension,
              version: history.version,
              revision: revisions,
              radicado: history.radicado,
              tarea_origen: history.tarea_origen
            });
          });
        }
        detailDocument.push({
          fecha: detail.fecha,
          folios: detail.folios,
          historial: record,
          id_documento: detail.id_documento,
          radicado: detail.radicado,
          documento_cita: detail.documento_cita,
          id_documento_cita: detail.id_documento_cita,
        });
      });
      // Copiando documento
      const doc: Documento = {
        clasificacion: newDoc.clasificacion,
        clasificacion_id: newDoc.clasificacion_id,
        codigo_documento: newDoc.codigo_documento,
        documentos_detalle: detailDocument,
        funciones: functionD,
        id_tipo_documental: newDoc.id_tipo_documental,
        id_expediente_cita: newDoc.id_expediente_cita,
        ruta_generacion: newDoc.ruta_generacion,
        ruta_vista_previa: newDoc.ruta_vista_previa,
        tipo_documental: newDoc.tipo_documental,
      };
      this.ctx.task.documentos.forEach((document, index) => {
        if (this.task.id === newDoc.idtarea && document.clasificacion_id === newDoc.clasificacion_id) {
          this.ctx.task.documentos[index] = doc;
        }
      });
      if (this.ctx.task.tarea_asociacion && this.ctx.task.tarea_asociacion.length) {
        this.ctx.task.tarea_asociacion.forEach(taskAssociation => {
          taskAssociation.documentos.forEach((document, index) => {
            if (
              taskAssociation.id_tarea_destino === newDoc.idtarea &&
              document.clasificacion_id === newDoc.clasificacion_id
            ) {
              taskAssociation.documentos[index] = doc;
            }
          });
        });
      }
    });
    this.updateTask(this.ctx.task);
    this.validDocs();
  }

  /**
   * Valida que todos los documentos se hayan subido y activa el boton de finalizar
   *
   * @memberof ElaborateComponent
   */
  validDocs() {
    let valid = true;
    if (this.task.documentos.length > 0) {
      for (let indexDoc = 0; indexDoc < this.task.documentos.length; indexDoc++) {
        let validUpload = false;
        if (this.task.documentos[indexDoc].funciones.length > 0) {
          for (let indexFuntion = 0;
            indexFuntion < this.task.documentos[indexDoc].funciones.length;
            indexFuntion++) {
            if (
              this.task.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
              this.task.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.dowload
            ) {
              if (this.task.documentos[indexDoc].funciones[indexFuntion].obligatorio) {
                validUpload = true;
                break;
              }
            }
          }
        }
        if (validUpload) {
          const uploadDoc = find(this.task.documentos[indexDoc].funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.upload});
          if (uploadDoc) {
            if (this.task.documentos[indexDoc].documentos_detalle.length > 0) {
              if (this.task.documentos[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                if (this.task.documentos[indexDoc].documentos_detalle[0].historial.length > 0) {
                  const versionDoc = this.task.documentos[indexDoc].documentos_detalle[0].historial.length;
                  for (let indexHistory = 0;
                    indexHistory < this.task.documentos[indexDoc].documentos_detalle[0].historial.length;
                    indexHistory++) {
                    if (this.task.documentos[indexDoc]
                      .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                      if (this.task.documentos[indexDoc]
                        .documentos_detalle[0].historial[indexHistory].revision.length) {
                        let idReview = 0;
                        for (let indexReview = 0;
                          indexReview < this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].revision.length;
                          indexReview++) {
                          if (this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory]
                            .revision[indexReview].id_revision > idReview) {
                            idReview = this.task.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory]
                              .revision[indexReview].id_revision;
                          }
                        }
                        for (let indexReview = 0;
                          indexReview < this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].revision.length;
                          indexReview++) {
                          if (this.task.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory]
                            .revision[indexReview].id_revision === idReview) {
                            if (!this.task.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory]
                              .revision[indexReview].revision) {
                              valid = false;
                              break;
                            } else {
                              valid = true;
                            }
                          }
                        }
                        if (!valid) {
                          break;
                        }
                      } else {
                        const currentSourceDocuments = filter(
                          this.task.documentos[indexDoc].documentos_detalle[0].historial,
                          {tarea_origen: this.task.id}
                        );
                        if (currentSourceDocuments && currentSourceDocuments.length) {
                          valid = true;
                        } else {
                          valid = false;
                          break;
                        }
                      }
                    }
                  }
                } else {
                  valid = false;
                  break;
                }
              } else {
                valid = false;
                break;
              }
            } else {
              valid = false;
              break;
            }
          } else {
            if (this.task.documentos[indexDoc].documentos_detalle.length > 0) {
              const doc = findIndex(
                this.documentsDownload,
                el => el === this.task.documentos[indexDoc].documentos_detalle[0].id_documento
              );
              if (doc !== -1) {
                valid = true;
              } else {
                valid = false;
                break;
              }
            } else if (this.documentsGenerated.length) {
              const doc = findIndex(
                this.documentsGenerated,
                {
                  idtarea: this.task.id,
                  clasificacion_id: this.task.documentos[indexDoc].clasificacion_id
                }
              );
              if (doc !== -1) {
                valid = true;
              } else {
                valid = false;
                break;
              }
            } else {
              valid = false;
              break;
            }
          }
        }
        if (!valid) {
          break;
        }
      }
    }
    if (valid) {
      if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
        for (const taskAssociation of this.task.tarea_asociacion) {
          if (taskAssociation.documentos.length > 0) {
            for (let indexDoc = 0; indexDoc < taskAssociation.documentos.length; indexDoc++) {
              let validUpload = false;
              if (taskAssociation.documentos[indexDoc].funciones.length > 0) {
                for (let indexFuntion = 0;
                  indexFuntion < taskAssociation.documentos[indexDoc].funciones.length;
                  indexFuntion++) {
                    if (
                      // tslint:disable-next-line: max-line-length
                      taskAssociation.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.upload ||
                      // tslint:disable-next-line: max-line-length
                    taskAssociation.documentos[indexDoc].funciones[indexFuntion].funcion === Const.DOCUMENTS_FUNCTIONS.dowload
                  ) {
                    if (taskAssociation.documentos[indexDoc].funciones[indexFuntion].obligatorio) {
                      validUpload = true;
                      break;
                    }
                  }
                }
              }
              if (validUpload) {
                const uploadDoc = find(
                  taskAssociation.documentos[indexDoc].funciones,
                  {funcion: Const.DOCUMENTS_FUNCTIONS.upload}
                );
                if (uploadDoc) {
                  if (taskAssociation.documentos[indexDoc].documentos_detalle.length > 0) {
                    if (taskAssociation.documentos[indexDoc].documentos_detalle[0].hasOwnProperty('historial')) {
                      if (taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length > 0) {
                        const versionDoc = taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length;
                        for (let indexHistory = 0;
                          indexHistory < taskAssociation.documentos[indexDoc].documentos_detalle[0].historial.length;
                          indexHistory++) {
                          if (taskAssociation.documentos[indexDoc]
                            .documentos_detalle[0].historial[indexHistory].version === versionDoc) {
                            if (taskAssociation.documentos[indexDoc]
                              .documentos_detalle[0].historial[indexHistory].revision.length) {
                              let idReview = 0;
                              for (let indexReview = 0;
                                indexReview < taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory].revision.length;
                                indexReview++) {
                                if (taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory]
                                  .revision[indexReview].id_revision > idReview) {
                                  idReview = taskAssociation.documentos[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory]
                                    .revision[indexReview].id_revision;
                                }
                              }
                              for (let indexReview = 0;
                                indexReview < taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory].revision.length;
                                indexReview++) {
                                if (taskAssociation.documentos[indexDoc]
                                  .documentos_detalle[0].historial[indexHistory]
                                  .revision[indexReview].id_revision === idReview) {
                                  if (!taskAssociation.documentos[indexDoc]
                                    .documentos_detalle[0].historial[indexHistory]
                                    .revision[indexReview].revision) {
                                    valid = false;
                                    break;
                                  } else {
                                    valid = true;
                                  }
                                }
                              }
                              if (!valid) {
                                break;
                              }
                            } else {
                              const currentSourceDocuments = filter(
                                taskAssociation.documentos[indexDoc].documentos_detalle[0].historial,
                                {tarea_origen: this.task.id}
                              );
                              if (currentSourceDocuments && currentSourceDocuments.length) {
                                valid = true;
                              } else {
                                valid = false;
                                break;
                              }
                            }
                          }
                        }
                      } else {
                        valid = false;
                        break;
                      }
                    } else {
                      valid = false;
                      break;
                    }
                  } else {
                    valid = false;
                    break;
                  }
                } else {
                  if (taskAssociation.documentos[indexDoc].documentos_detalle.length > 0) {
                    const doc = findIndex(
                      this.documentsDownload,
                      el => el === taskAssociation.documentos[indexDoc].documentos_detalle[0].id_documento
                    );
                    if (doc !== -1) {
                      valid = true;
                    } else {
                      valid = false;
                      break;
                    }
                  } else if (this.documentsGenerated.length) {
                    const doc = findIndex(
                      this.documentsGenerated,
                      {
                        idtarea: taskAssociation.id_tarea_destino,
                        clasificacion_id: taskAssociation.documentos[indexDoc].clasificacion_id
                      }
                    );
                    if (doc !== -1) {
                      valid = true;
                    } else {
                      valid = false;
                      break;
                    }
                  } else {
                    valid = false;
                    break;
                  }
                }
              }
              if (!valid) {
                break;
              }
            }
            if (!valid) {
              break;
            }
          }
        }
      }
    }
    if (valid) {
      this.isDisabledBtnFinish = false;
    } else {
      this.isDisabledBtnFinish = true;
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof ElaborateComponent
   */
  finishConfirm() {
    if (!this.isDisabledBtnFinish && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (this.isDisabledBtnFinish) {
          this.toastr.error('Por Favor ingrese toda la información requerida.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/all/elaborate/elaborate.component.ts